/** Stable React key for create vs edit forms (BUG-F1-181). */
export const entityFormKey = (entityId: number | null | undefined): string =>
  entityId != null ? `edit-${entityId}` : "create";
